import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Article } from '../blog-models/Article';
import { ArticleService } from '../blog-services/article.service';

@Component({
  selector: 'app-new-article',
  templateUrl: './new-article.component.html',
  styleUrls: ['./new-article.component.scss']
})
export class NewArticleComponent implements OnInit {

    articleForm: FormGroup;
    titleIsValid: boolean;
    messageErrorTitle: string;
    introIsValid: boolean;
    messageErrorIntro: string;
    fileIsUploading = false;
    fileUrl: string;
    fileUploaded = false;

    constructor(private articleService: ArticleService,
        private formBuilder: FormBuilder, 
        private router: Router, 
        private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.initForm();
    }

    /**
     * Initialiser le formulaire.
     * Si on reçoit des paramètres depuis l'URL 
     * On les intègres aux champs du formulaire
     * Pour le cas d'une page de validation ( pas encore existante)
     */
    initForm(): void {
        // Récupérer les params de la route
        const params = {
            title: this.route.snapshot.params['title'],
            pathImg: this.route.snapshot.params['pathImg'],
            intro: this.route.snapshot.params['intro'],
            content: this.route.snapshot.params['content'],            
        }
        // renseigner les champs avec les valeurs récupérées en params de la route
        this.articleForm = this.formBuilder.group({
            title: [params.title, [Validators.required, Validators.minLength(3)]],
            pathImg: [params.pathImg, [Validators.required, Validators.pattern(/([a-zA-Z0-9\s_\\.\-\(\):])+(.jpg|.jpeg|.png|.JPG|.JPEG|.PNG)/)]],
            intro: [params.intro, [Validators.required]],
            content: [params.content, [Validators.required]]
        });
    }

    /**
     * Valider la taille minimal du titre
     */
    testTitle() {
        // Tester que le titre n'est pas vide
        if (this.articleForm.value['title']) {
            // Si pas vide: Vérifier qu'il fait au moins 3 charactères
            if (this.articleForm.value['title'].length >= 3 ) {
                this.titleIsValid = true;
                this.messageErrorTitle = "";
            // Si moins de 3 charactères: ajouter message d'erreur
            } else {
                this.titleIsValid = false;
                this.messageErrorTitle = "Le titre doit contenir au moins 3 charactères";
            }
        // Si vide: Ajouter message d'erreur
        } else {
            this.titleIsValid = false;
            this.messageErrorTitle = "Le titre ne peut pas être vide";
        }
    }

    /**
     * Valider que l'introduction n'est pas vide
     */
    testIntro() {
        // Tester si l'intro n'est pas vide
        if (this.articleForm.value['intro']) {
            this.introIsValid = true;
            this.messageErrorIntro = "";
        // Si vide on ajoute un message d'erreur
        } else {
            this.introIsValid = false;
            this.messageErrorIntro = "L'intro ne peut pas être vide";
        }
    }

    /**
     * Rediriger vers la page de confirmation
     * En passant en paramètre les valeurs dans les champs du formulaire
     */
    onSubmitForm(): void {
        // Créer l'article avec les données fournies dans le formaulaire
        const newArticle = new Article();
        newArticle.date = new Date().toLocaleString().split(',')[0];
        newArticle.title = this.articleForm.get('title').value;
        newArticle.intro = this.articleForm.get('intro').value;
        newArticle.content = this.articleForm.get('content').value;
        // tester que le chemin de l'image n'est pas vide
        if(this.fileUrl && this.fileUrl !== '') {
            newArticle.pathImg = this.fileUrl;
        }

        // Créer l'article en BDD et MAJ des listes des articles
        this.articleService.createNewArticle(newArticle);
        // Rediriger vers la page du nouvel article
        this.router.navigate(['/blog', this.articleService.getLastIndex()]);
    }

    /**
     * Stocker l'image en BDD
     * @param file 
     */
    onUploadFile(file: File) {
        this.fileIsUploading = true;
        this.articleService.uploadFile(file).then(
            (url: string) => {
                this.fileUrl = url;
                this.fileIsUploading = false;
                this.fileUploaded = true;
            }
        );
    }

    /**
     * Supprimer l'image déjà enregistré sur firease
     */
    onUnuploadFile() {
        if(this.fileUrl != null) {
            this.fileIsUploading = false;
            this.fileUploaded = false;
            this.articleService.removeImage(this.fileUrl);
        }
    }

    /**
     * Appelé quand le champs de l'image perd le focus
     * @param event 
     */
    detectFiles(event) {
        this.onUploadFile(event.target.files[0]);
    }
}
